module.exports = __webpack_public_path__ + "img/selected.f7f599db.svg";